import { Component, OnInit } from '@angular/core';

import { CacheService } from '../../../shared/services/cache.service';
import { OrganizacaoAtivaService } from '../../../shared/services/organizacao-ativa.service';

@Component({
  selector: 'organizacao-switcher',
  templateUrl: './organizacao-switcher.component.html',
  styleUrls: ['./organizacao-switcher.component.scss'],
})
export class OrganizacaoSwitcherComponent implements OnInit {
  organizacoes: Array<any> = [];
  organizacaoAtiva: any = null;
  trocandoParaId: string | null = null;

  constructor(
    private organizacaoAtivaService: OrganizacaoAtivaService,
    private cacheService: CacheService
  ) {}

  ngOnInit() {
    this.organizacaoAtivaService.sincronizar();

    this.organizacaoAtivaService.observeOrganizacoes().subscribe((organizacoes) => {
      this.organizacoes = organizacoes;
    });

    this.organizacaoAtivaService.observeOrganizacaoAtiva().subscribe((organizacao) => {
      this.organizacaoAtiva = organizacao;
    });
  }

  get visivel(): boolean {
    return this.organizacoes.length > 1;
  }

  get trocando(): boolean {
    return this.trocandoParaId !== null;
  }

  isAtiva(organizacao: any): boolean {
    return !!organizacao?.id && organizacao.id === this.organizacaoAtiva?.id;
  }

  getInitials(name: string): string {
    if (!name) return '';
    const names = name
      .trim()
      .split(/\s+/)
      .filter((n) => n.length > 0);
    if (names.length === 0) return '';

    const firstChar = names[0].charAt(0).toUpperCase();
    const lastChar =
      names.length > 1 ? names[names.length - 1].charAt(0).toUpperCase() : '';
    return firstChar + lastChar;
  }

  trocar(organizacao: any) {
    if (this.trocando || this.isAtiva(organizacao)) return;

    this.trocandoParaId = organizacao?.id ?? null;

    if (!this.organizacaoAtivaService.setOrganizacaoAtiva(organizacao?.id)) {
      this.trocandoParaId = null;
      return;
    }

    this.cacheService.clearCache();

    const base = window.location.href.split('#')[0];
    window.location.href = `${base}#/${this.organizacaoAtivaService.getHomeRoute()}`;
    window.location.reload();
  }
}
